import tag from 'src/internal/shared/graphql/tag';

/**
 * @see https://sail.stripe.me/data/api/gql
 */
export default tag;
